import { useQuery } from '@tanstack/react-query';
import { PartnerWithCategory } from '../types/types';
import { QUERY_KEYS } from '../constants/queryKeys';
import { callPublicAPI } from '../utils/api';
import { STALE_TIME } from '../constants/staleTime';

interface FetchPartnersByCategoryParams {
  offset?: number;
  limit?: number;
  activeFor?: number;
  categoryId?: string;
  [key: string]: string | number | undefined; // Allow flexibility for additional params
}

export const useFetchPartnersByCategory = (params?: FetchPartnersByCategoryParams) => {
  return useQuery<PartnerWithCategory[]>({
    queryKey: [QUERY_KEYS.GET_PARTNERS, params?.categoryId],
    queryFn: async () => {
      const requestSearchParams = new URLSearchParams({
        offset: params?.offset?.toString() || '0',
        limit: params?.limit?.toString() || '100',
        activeFor: '1000',
        segment: 'a,b',
        category: params?.categoryId || ''
      });

      // Remove empty query parameters
      Array.from(requestSearchParams.keys()).forEach(key => {
        if (!requestSearchParams.get(key)) {
          requestSearchParams.delete(key);
        }
      });

      const response = await callPublicAPI<PartnerWithCategory[]>('GET', '/partners', requestSearchParams);

      return response.data;
    },
    staleTime: STALE_TIME.HOUR
  });
};
